// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","AppLogo":"App_AppLogo__0tFJw","App-logo-spin":"App_App-logo-spin__t6jjo","AppHeader":"App_AppHeader__DJCyc","AppLink":"App_AppLink__xrxGv"};